/* @flow */
import * as React from 'react';

const Dollar = ({ color, ...props }) => (
  <svg width={13} height={23} viewBox="0 0 13 23" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill={color}
      fillRule="evenodd"
      d="M13.009,15.517 C13.009,16.93 12.389,18.046 11.57,18.865 C10.554,19.857 9.14,20.402 7.602,20.551 L7.602,22.808 L6.164,22.808 L6.164,20.551 C4.602,20.427 3.262,19.882 2.221,18.939 C1.13,17.947 0.46,16.534 0.46,14.922 L2.642,14.922 C2.642,15.938 3.089,16.93 3.808,17.575 C4.453,18.17 5.246,18.493 6.164,18.617 L6.164,12.59 C5.866,12.541 5.544,12.491 5.246,12.466 C2.816,12.169 0.906,10.582 0.906,8.002 C0.906,6.738 1.477,5.522 2.37,4.679 C3.461,3.638 4.726,3.142 6.164,3.018 L6.164,0.736 L7.602,0.736 L7.602,3.042 C8.966,3.191 10.206,3.712 11.149,4.63 C12.166,5.622 12.736,6.787 12.786,8.226 L10.578,8.226 C10.529,7.333 10.231,6.564 9.686,5.994 C9.165,5.448 8.495,5.076 7.602,4.952 L7.602,10.606 L8.346,10.706 C11.025,11.053 13.009,12.64 13.009,15.517 Z M6.164,10.458 L6.164,4.927 C5.246,5.026 4.428,5.324 3.783,6.018 C3.337,6.514 3.089,7.184 3.089,7.953 C3.089,9.441 4.106,10.185 5.445,10.358 L6.164,10.458 Z M10.826,15.566 C10.826,13.954 9.661,13.012 7.999,12.814 L7.602,12.764 L7.602,18.617 C8.545,18.518 9.314,18.22 9.934,17.625 C10.454,17.129 10.826,16.484 10.826,15.566 Z"
    />
  </svg>
);

export default Dollar;



// WEBPACK FOOTER //
// ./src/assets/images/icons/dollar.js